export default "__VITE_ASSET__1a2fa6ac__"